<template>
  <div class="crystal-card" v-motion-slide-visible-bottom>
    <div class="flex items-start gap-3 mb-4">
      <!-- Avatar -->
      <div class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center bg-gradient-to-br border"
           :class="[avatarData.gradient, avatarData.border]">
        <AvatarIcon :avatar-id="wish.avatar" size="sm" />
      </div>

      <div class="flex-1 min-w-0 space-y-0.5">
        <h3 class="text-base font-semibold text-nirvana-white/90 truncate">
          <span class="text-nirvana-cyan/40 font-normal text-sm">#{{ wish.number }}</span>
          <span class="mx-1 text-nirvana-purple/20">·</span>
          {{ wish.name }}
        </h3>
        <a 
          v-if="wish.twitter"
          :href="`https://twitter.com/${cleanTwitterHandle(wish.twitter)}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-xs text-nirvana-lotus/50 hover:text-nirvana-lotus transition-colors inline-flex items-center gap-0.5"
        >
          @{{ cleanTwitterHandle(wish.twitter) }}
        </a>
      </div>
    </div>

    <p class="text-nirvana-silver/70 mb-4 whitespace-pre-wrap leading-relaxed text-[15px]">{{ wish.message }}</p>

    <img
      v-if="wish.fanart"
      :src="wish.fanart"
      :alt="`แฟนอาร์ตโดย ${wish.name}`"
      class="w-full rounded-lg mb-4 ring-1 ring-white/5"
      loading="lazy"
    />

    <div class="ornate-divider mb-3"></div>
    <div class="flex justify-between items-center">
      <span class="text-xs text-nirvana-silver/25">
        {{ formatDate(wish.createdAt) }}
      </span>
      
      <div class="flex space-x-1">
        <button
          v-for="(social, index) in socials"
          :key="index"
          @click="shareWish(social.type)"
          class="p-1.5 text-nirvana-silver/20 hover:text-nirvana-cyan transition-colors rounded-lg hover:bg-nirvana-cyan/5"
          :title="`Share on ${social.name}`"
        >
          <component :is="social.icon" class="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Twitter, Facebook, Link } from 'lucide-vue-next'
import { format } from 'date-fns'
import { getAvatarById } from '@/config/avatars'
import AvatarIcon from '@/components/AvatarIcon.vue'
import { cleanTwitterHandle } from '@/utils/formatters'

const props = defineProps({
  wish: {
    type: Object,
    required: true
  }
})

const avatarData = computed(() => getAvatarById(props.wish.avatar))

const socials = [
  { type: 'twitter', name: 'Twitter', icon: Twitter },
  { type: 'facebook', name: 'Facebook', icon: Facebook },
  { type: 'copy', name: 'Copy Link', icon: Link }
]

function formatDate(date) {
  return format(new Date(date), 'MMM d, yyyy')
}

function shareWish(type) {
  const text = `มาอวยพรวันเกิดให้น้องเนอร์กัน~! #HBDNirvana2026 #NirvanaARP #UtopiaARP #ARProject`
  const url = `${window.location.origin}/wish/${props.wish.number}`

  switch (type) {
    case 'twitter':
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`)
      break
    case 'facebook':
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)
      break
    case 'copy':
      navigator.clipboard.writeText(url)
      break
  }
}
</script>
